// extracted by mini-css-extract-plugin
export default {"illustrationContainer":"mqBR"};